<template>
  <div class="hidden">
    <form name="Login" id="recLogin" method="post" :action="credential.login_page_url" target="_blank">
      <input type="hidden" placeholder="Username" name="name" :value="credential.name" tabindex="1">
      <input type="hidden" placeholder="Username" name="username" :value="credential.username" tabindex="1">
      <input type="hidden" placeholder="Password" name="password" :value="credential.password" tabindex="2">
    </form>
  </div>
</template>

<script>

import Utils from '@/helpers/utils'
import {EventBus} from '@/../eventbus'
import Company from '@/models/Company'

export default {
  name: 'Global.Popup.RecordingManager',
  components: {
    Utils
  },
  data () {
    return {
      credential: {
        login_page_url: '',
        name: '',
        username: '',
        password: ''
      }
    }
  },
  mounted () {
    EventBus.$on('initLoadRecordingManagerSettings', this.loadRecordingManagerSettings)
    EventBus.$on('initExternalLinkToRecordingManager', this.externalLinkToRecordingManager)
    this.loadRecordingManagerSettings()
  },
  methods: {
    async loadRecordingManagerSettings () {
      const response = await Company.recSystemCredential()
      this.credential = response.data
    },
    async externalLinkToRecordingManager () {
      await this.loadRecordingManagerSettings()
      document.getElementById('recLogin').submit()
      this.resetCredential()
    },
    resetCredential () {
      this.credential = {
        login_page_url: '',
        name: '',
        username: '',
        password: ''
      }
    }
  }
}
</script>
